import { configureStore } from "@reduxjs/toolkit";
import { middlewareApi } from "../middlewares/middlewareApi";
import commonSlice from "../slices/commonSlice";
import authSlice from "../slices/auth/authSlice";
import clientesSlice from "../modules/clientes/slices/clientesSlice";
import usersSlice from "../modules/usuarios/slices/usersSlice";
import blImportSlice from "../modules/bl-imports/slices/blImportSlice";
import blExportSlice from "../modules/bl-exports/slices/BlExportSlice";

export const store = configureStore({
  reducer: {
    [middlewareApi.reducerPath]: middlewareApi.reducer,
    common: commonSlice,
    auth: authSlice,
    usuarios: usersSlice,
    clientes: clientesSlice,
    blImport: blImportSlice,
    blExport: blExportSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      middlewareApi.middleware
    ),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
